<template>
  <div class="l-content-inner">
    <PwFind v-if="currentStep === 1" @next="onPwFindNext" />
    <PwFindComplete v-if="currentStep === 2" :tmp-password="tmpPassword" />
  </div>
</template>
<script setup>
import PwFind from "@/components/paintpro/member/pwFind.vue";
import PwFindComplete from "@/components/paintpro/member/pwFindComplete.vue";
import { onMounted, ref } from "vue";

const currentStep = ref(1); // 1: find / 2: complete
const tmpPassword = ref(null);

onMounted(() => {});

const onPwFindNext = (_tmpPassword) => {
  tmpPassword.value = _tmpPassword;
  currentStep.value = 2;
};
</script>
